// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ebfcd1cf","455":"1d5ef264","727":"7c349a3f","821":"670db343","977":"a2a6f68c"}[chunkId] + ".chunk.js";
};